import { createApimApiClient } from "../createApimClient";

export const hotelInfoServiceClient = createApimApiClient(
	process.env.GATSBY_HOTEL_INFOSERVICE_API,
	process.env.GATSBY_HOTEL_INFOSERVICE_APIM_SUB_KEY
);
